module.exports = __webpack_public_path__ + "img/tecent-meeting-icon.bfcb1d7a.png";